/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

var Point = require('./Point');

Point.Ceil = require('./Ceil');
Point.Clone = require('./Clone');
Point.CopyFrom = require('./CopyFrom');
Point.Equals = require('./Equals');
Point.Floor = require('./Floor');
Point.GetCentroid = require('./GetCentroid');
Point.GetMagnitude = require('./GetMagnitude');
Point.GetMagnitudeSq = require('./GetMagnitudeSq');
Point.GetRectangleFromPoints = require('./GetRectangleFromPoints');
Point.Interpolate = require('./Interpolate');
Point.Invert = require('./Invert');
Point.Negative = require('./Negative');
Point.Project = require('./Project');
Point.ProjectUnit = require('./ProjectUnit');
Point.SetMagnitude = require('./SetMagnitude');

module.exports = Point;



//////////////////
// WEBPACK FOOTER
// ./node_modules/phaser/src/geom/point/index.js
// module id = 786
// module chunks = 0